const breakpoints = {
	values: {
		xs: 0,		// Extra Small
		sm: 640,	// Small
		ms: 920,	// Medium-Small (this size was introduced to find a middish-point between small and medium for landscape orientation)
		md: 1024,	// Medium
		lg: 1180,	// Large
		xl: 1510	// Xtra-Large
	}
}

export default breakpoints;